import React from 'react';
import cx from 'classnames';

import { SiteConfigManager } from '@atlas/core';
import { Loader } from '@atlas/ui';

const SearchLoader = () => {
  const view = SiteConfigManager.getConfig('config.config.sportsbook.mobileGridViewType');

  const className = cx('search-loader', {
    simplified: view === 'simplified',
  });

  return <Loader className={className} />;
};

export default SearchLoader;
